import { asPreset, asSelection, lastDayOf, TIME_PRESETS, type TimePreset, type TimeRange, type TimeSelection } from "@cd/core";

export { asPreset, asSelection, TIME_PRESETS, type TimePreset, type TimeSelection };

export const selectionLabel = (t: TimeSelection) => (t.timeRange ? describeRange(t.timeRange) : presetLabel(t.timePreset).toLowerCase());

export const presetLabel = (p: TimePreset) => TIME_PRESETS.find((x) => x.id === p)?.label ?? p;

export const iso = (d: Date) =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
export const addDays = (d: Date, n: number) => new Date(d.getFullYear(), d.getMonth(), d.getDate() + n);

/** Approximate, for labels: inclusive dates in the viewer's calendar. "Last N days" excludes today. */
export function presetRange(preset: string, now = new Date()): TimeRange {
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  switch (preset) {
    case "today": return { start: iso(today), end: iso(today) };
    case "yesterday": return { start: iso(addDays(today, -1)), end: iso(addDays(today, -1)) };
    case "last_7_days": return { start: iso(addDays(today, -7)), end: iso(addDays(today, -1)) };
    case "last_week": {
      const monday = addDays(today, -((today.getDay() + 6) % 7));
      return { start: iso(addDays(monday, -7)), end: iso(addDays(monday, -1)) };
    }
    case "last_90_days": return { start: iso(addDays(today, -90)), end: iso(addDays(today, -1)) };
    case "month_to_date": return { start: iso(new Date(today.getFullYear(), today.getMonth(), 1)), end: iso(today) };
    case "last_month":
      return { start: iso(new Date(today.getFullYear(), today.getMonth() - 1, 1)), end: iso(addDays(new Date(today.getFullYear(), today.getMonth(), 1), -1)) };
    default: return { start: iso(addDays(today, -30)), end: iso(addDays(today, -1)) };
  }
}

export function describeRange(r: TimeRange): string {
  const fmt = (s: string) => new Date(`${s.slice(0, 10)}T00:00:00`).toLocaleDateString(undefined, { month: "short", day: "numeric" });
  const e = lastDayOf(r);
  return e === r.start.slice(0, 10) ? fmt(r.start) : `${fmt(r.start)} – ${fmt(e)}`;
}

/** Picker dates (YYYY-MM-DD) as a range: both ends are included, in either order. */
export function customRange(first: string, last: string): TimeRange {
  const [a, b] = first <= last ? [first, last] : [last, first];
  return { start: a, end: b };
}
